module.exports = __webpack_public_path__ + "img/Box-3.539f173c.png";